export default __webpack_public_path__ + "static/media/1.994a2472.jpg";